<div class="nav-list-content" [ngClass]="{ inactive: isDisabled, selected: isActive && !isDisabled }">
	<div class="printable_button" *ngIf="isActive && !isDisabled">
		<app-printable-report-item-r1></app-printable-report-item-r1>
	</div>

	<li
		(click)="allow ? navigate() : (allow = false)"
		[ngClass]="{ inactive: isDisabled, selected: isActive && !isDisabled }"
	>
		<div>
			<span class="sectiontitle" [ngClass]="sectiontitle + '_nav_link'"
				>{{ sectiontitle }}
				<div class="tooltip-container" *ngIf="(isR6 || isR11) && sectiontitle === 'DOOH'">
					<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
							fill="white"
						/>
						<path
							class="dooh-svg-background"
							d="M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
							fill="white"
						/>
						<path
							d="M7.45689 9.382L7.21888 5.914L7.16222 4.40667H8.83955L8.78289 5.914L8.54489 9.382H7.45689ZM8.00089 12.136C7.71377 12.136 7.472 12.0378 7.27555 11.8413C7.08666 11.6373 6.99222 11.388 6.99222 11.0933C6.99222 10.7911 7.08666 10.5418 7.27555 10.3453C7.472 10.1413 7.71377 10.0393 8.00089 10.0393C8.288 10.0393 8.526 10.1413 8.71489 10.3453C8.91133 10.5418 9.00955 10.7911 9.00955 11.0933C9.00955 11.388 8.91133 11.6373 8.71489 11.8413C8.526 12.0378 8.288 12.136 8.00089 12.136Z"
							fill="white"
						/>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						style="display: none"
						class="dooh-svg-icon-r1101"
					>
						<path
							d="M6.4375 8H5.9375V6H5.4375M5.9375 4H5.9425M10.4375 6C10.4375 8.48528 8.42278 10.5 5.9375 10.5C3.45222 10.5 1.4375 8.48528 1.4375 6C1.4375 3.51472 3.45222 1.5 5.9375 1.5C8.42278 1.5 10.4375 3.51472 10.4375 6Z"
							stroke="#2E2E2E"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span class="tooltip-text" *ngIf="isR6"
						>Impression totals may vary slightly between different widgets due to the nature of DOOH advertising</span
					>
					<span class="tooltip-text" *ngIf="isR11"
						>The nature of DOOH advertising means that some impressions might change between different ad groups.
						Because of the way impressions are calculated, there might be slight differences in the numbers of
						impressions shown in different widgets.</span
					>
				</div>
			</span>
			<div class="download_report" *ngIf="isR6">
				<div class="child" *ngIf="loadR6Printable">
					<app-printable-report-component-r6 class="download_report_pdf"></app-printable-report-component-r6>
					<app-product-csv-downnload-r6 [key]="sectiontitle" class="download_report_csv"></app-product-csv-downnload-r6>
				</div>
			</div>
			<span *ngIf="downloadConfiguration.enableDownload && !isDisabled">
				<a href="javascript:void(0)" target="_blank" (click)="downloadCSV($event)">
					<i
						class="fa fa-download downloadIcon"
						aria-hidden="true"
						style="font-size: 0.8em; color: #000; top: 2px; position: relative"
					></i>
				</a>
			</span>
			<span class="underline"> </span>
		</div>
	</li>
</div>
